<template lang="html">
  <div class="max-width">
    <p v-if="label != ''" class="pt-0 mb-0 small">
      {{ label }}
    </p>
    <b-form-select v-model="_value" size="sm" :options="options" />
  </div>
</template>

<script>
export default {
  name: "DropdownSelect",
  props: {
    value: {
      type: String,
      default: () => ""
    },
    label: {
      type: String,
      default: () => ""
    },
    options: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    _value: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("changed", value);
      }
    }
  }
};
</script>

<style lang="css" scoped>
.max_width {
  max-width: 200px;
}
</style>
